import { Gara } from "../types/gare/gara";
import { ApiService } from "./apiService";
import { ENDPOINTS } from "../config/apiConfig";
import { ApiResponse } from "../types/apiResponse";
import { Concorrente } from "../types/concorrenti/concorrente";

export interface Group {
  groupId: number;
  competitors: Concorrente[];
}

export class GaraService {
  static async getGareList(
    page: number = 1,
    pageSize: number = 8,
    searchTerm?: string,
    orderBy?: "Name" | "CompetitionDate" | "Location",
    desc?: boolean,
    discipline?: number
  ): Promise<ApiResponse<Gara>> {
    const params = new URLSearchParams({
      pageNumber: String(page),
      pageSize: String(pageSize),
    });
    if (discipline) params.append("discipline", String(discipline));
    if (searchTerm) {
      params.append("search", searchTerm);
    }
    if (orderBy) {
      params.append("orderBy", orderBy);
    }
    if (desc) {
      params.append("desc", "true");
    }
    return ApiService.client.get<ApiResponse<Gara>>(
      `${ENDPOINTS.GARE.LIST}?${params.toString()}`
    );
  }

  static async getGaraById(id: number): Promise<Gara> {
    return ApiService.client.get<Gara>(ENDPOINTS.GARE.GET_BY_ID(id));
  }

  static async createGara(gara: Omit<Gara, "id">): Promise<Gara> {
    return ApiService.client.post<Gara>(ENDPOINTS.GARE.CREATE, gara);
  }

  static async updateGara(id: number, gara: Partial<Gara>): Promise<Gara> {
    return ApiService.client.put<Gara>(ENDPOINTS.GARE.UPDATE(id), gara);
  }

  static async deleteGara(id: number): Promise<void> {
    return ApiService.client.delete<void>(ENDPOINTS.GARE.DELETE(id));
  }
  static async addConcorrente(
    garId: number,
    concorrenteId: number
  ): Promise<void> {
    return ApiService.client.post<void>(
      ENDPOINTS.GARE.ADD_CONCORRENTE(garId, concorrenteId)
    );
  }

  // Remove concorrente from gara
  static async removeConcorrente(
    garaId: number,
    concorrenteId: number
  ): Promise<void> {
    return ApiService.client.delete<void>(
      ENDPOINTS.GARE.DELETE_CONCORRENTE(garaId, concorrenteId)
    );
  }

  static async createGroup(group: any): Promise<void> {
    return ApiService.client.post<void>(ENDPOINTS.GARE.CREATE_GROUP, group);
  }

  static async getGroups(competitionId: number): Promise<Group[]> {
    return ApiService.client.get<Group[]>(ENDPOINTS.GARE.GET_GROUP(competitionId));
  }

  static async deleteGroup(competitionId: number, competitorIds: number[]): Promise<void> {
    // POST per compatibilità con l'API RemoveGroup che accetta un body
    return ApiService.client.post<void>(
      ENDPOINTS.GARE.DELETE_GROUP(competitionId),
      { competitorIds }
    );
  }
}
